import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  root: {
    backgroundColor: 'var(--x-bg-1)',
    height: '100vh',
    overflow: 'hidden',
    width: '100vw',
  },
  '@global': {
    '*': {
      margin: 0,
      padding: 0,
      boxSizing: 'border-box',
    },
    html: {
      height: '100%',
    },
    body: {
      height: '100%',
    },
  },
  tooltip: {
    fontSize: 14,
    lineHeight: '20px',
  },
});

export default useStyles;
